import React from 'react'
import classes from "./Technologies.module.css"
import html from "../../Assets/Images/html.png"
import css from "../../Assets/Images/css.png"
import javascript from "../../Assets/Images/javascript.png"
import react from "../../Assets/Images/react.png"

const Technologies = () => {
  return (
    <section className={classes.associate_section}>
      <h2>Technologies</h2>

      <div className={classes.asscoiate_logo_wrapper}>
        {/* <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9Lnm0K-Cbz4eTj44xNdkW0c1dk4Jl2Xe1qw&s"
          alt=""
        /> */}
        <img
          src={react}
          alt=""
        />
        {/* <img
          src="https://media.licdn.com/dms/image/v2/D5612AQGHR-FEVGwWFQ/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1693497056904?e=2147483647&v=beta&t=FRAYmju0yddmAge4oZDd3KQroonU7oeiLM8CN18sHuM"
          alt=""
        /> */}
        <img
          src={html}
          alt=""
        />
        {/* <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRhvYSTw2Q476FtD17sdEc97bCyLIatotOO2w&s"
          alt=""
        /> */}
        <img
          src={css}
          alt=""
        />
        {/* <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwAMVIYFU7fBkYkhI_BGVqizydCiwjRIJvjQ&s"
          alt=""
        /> */}
        <img
          src={javascript}
          alt=""
        />
      </div>
    </section>
  );
}

export default Technologies;
